import { Routes } from '@angular/router';
import { PaymentsExternalRoute } from './payments-external.routes.enum';
import { paymentsEnabledGuard } from './core/guards/payments-enabled/payments-enabled.guard';

export const paymentsExternalRoutes: Routes = [
  {
    path: PaymentsExternalRoute.ThreeDSecure,
    loadComponent: () =>
      import('./pages/payments/payment-three-d-secure-authentication/payment-three-d-secure-authentication.component').then(
        (m) => m.PaymentThreeDSecureAuthenticationComponent,
      ),
    canActivate: [paymentsEnabledGuard],
  },
];
